import { createRouter, createWebHistory } from 'vue-router';
//登录页
import Login from '../pages/auth/login.vue'

//首页
import home from '../pages/index/index.vue';

//营地管理
import campAdmin from '../pages/camp/camp-admin/camp-admin.vue'
import campAdd from '../pages/camp/camp-admin/camp-add.vue'
import campEdit from '../pages/camp/camp-admin/camp-edit.vue'
import campDetail from '../pages/camp/camp-admin/camp-detail.vue'
import campRate from '../pages/camp/camp-rate/camp-rate.vue'

//运营管理
import homeAdmin from '../pages/operation/home-admin/home-admin.vue'
import searchAdmin from '../pages/operation/search-admin/search-admin.vue'
import categoryAdmin from '../pages/operation/category-admin/category-admin.vue'

//用户管理
import userAdmin from '../pages/user/user-admin.vue'
import userDetail from '../pages/user/user-detail/user-detail.vue'

//系统管理
import facilityAdmin from '../pages/set/facility-admin/facility-admin.vue'
import agreementAdmin from '../pages/set/agreement-admin/agreement-admin.vue'
import setting from '../pages/set/setting/setting.vue'

const routes = [

    {
        path: '/auth/login',
        name: 'login',
        component: Login,
        meta: { noLayout: true }  // 设置 meta 字段，表示该页面不使用 Layout
    },

    {
        path: '/',
        name: 'home',
        component: home
    },

    //营地管理
    {
        path: '/camp/camp-admin',
        name: 'campAdmin',
        component: campAdmin
    },
    {
        path: '/camp/camp-add',
        name: 'campAdd',
        component: campAdd
    },
    {
        path: '/camp/camp-edit/:id',
        name: 'campEdit',
        component: campEdit,
        props: true 
    },
    {
        path: '/camp/camp-detail/:id',
        name: 'campDetail',
        component: campDetail,
        props: true
    },

    //营地评价管理
    {
        path: '/camp/camp-rate',
        name: 'campRate',
        component: campRate
    },

    //首页管理
    {
        path: '/operation/home-admin',
        name: 'homeAdmin',
        component: homeAdmin
    },

    //搜索管理
    {
        path: '/operation/search-admin',
        name: 'searchAdmin',
        component: searchAdmin
    },

    //分类页管理
    {
        path: '/operation/category-admin',
        name: 'categoryAdmin',
        component: categoryAdmin
    },

    //用户管理
    {
        path: '/user/user-admin',
        name: 'userAdmin',
        component: userAdmin
    },

    //用户详情
    {
        path: '/user/user-detail/:id',
        name: 'userDetail',
        component: userDetail,
        props: true
    },
    
    
    //设施管理
    {
        path: '/set/facility-admin',
        name: 'facilityAdmin',
        component: facilityAdmin
    },

    //服务协议管理
    {
        path: '/set/agreement-admin',
        name: 'agreementAdmin',
        component: agreementAdmin
    },

    //设置
    {
        path: '/set/setting',
        name: 'setting',
        component: setting
    },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

//全局前置守卫
router.beforeEach((to, from, next) => {
    const isAuth = !!localStorage.getItem('token');
    const isLoginPage = to.name === 'login';
  
    if (!isAuth && !isLoginPage) {
      // 如果没有 token 且不是登录页，重定向到登录页
      next({ name: 'login' });
    } else if (isAuth  && isLoginPage) {
      // 如果有 token 且是登录页，重定向到首页
      next({ name: 'home' });
    } else {
      next();
    }
  });

export default router;